import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import {
  CmsService,
  LanguageService,
  ProductService,
  RoutingService,
  TranslationService,
} from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { CustomProfileAndPreferencesService } from 'src/app/custom-profile-and-preferences/custom-profile-and-preferences.service';
import { ChannelSelectComponent } from 'src/app/shared/modules/channel-select/channel-select.component';
import { CheckoutService } from 'src/app/shared/modules/checkout/checkout.service';

@Component({
  selector: 'app-acc-overview-placeholder1',
  templateUrl: './acc-overview-placeholder1.component.html',
})
export class AccOverviewPlaceholder1Component implements OnInit, OnDestroy {
  accountNumber: string = null;
  accountCnpj: string = null;
  compNameAdBanner = 'SanofiAccountOverviewBannerComponent4';
  compNameAdBanner2 = 'SanofiAccountOverviewBannerComponent2';
  compNameAdBanner3 = 'SanofiAccountOverviewBannerComponent3';
  compNameAdBanner6 = 'SanofiAccountOverviewBannerComponent6';
  compNameAdBanner1 = 'SanofiAccountOverviewBannerComponent';
  cmsResponse: any;
  productCodes: any;
  prodcutsInfo: any = [];
  prodDocs: any = [];
  prodDocus: any = [];
  fluResevartion: boolean;
  selectedChannel: string = sessionStorage.getItem('selectedChannel');
  customerGroupType: string = '';
  modalOption: NgbModalOptions = {};
  subEmulating: Subscription;
  subB2b: Subscription;
  subUser: Subscription;
  subMonograph: Subscription;
  subProduct: Subscription;

  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly router: RoutingService,
    private readonly cmsData: CmsService,
    protected productService: ProductService,
    private readonly checkoutService: CheckoutService,
    private readonly lang: LanguageService,
    private readonly modalService: NgbModal,
    private readonly translateService: TranslationService,
    private readonly user: UserAccountFacade,
    private readonly profilePrefService: CustomProfileAndPreferencesService
  ) {}

  ngOnInit(): void {
    this.lang.getActive().subscribe((res) => {
      if (res) {
        this.prodcutsInfo = [];
      }
    });
    this.subUser = this.user
      .get()
      .pipe(take(2))
      .subscribe((user) => {
        if (user) {
          this.getDefaultB2b(user?.uid);
        }
      });
    this.subMonograph = this.cmsData
      .getComponentData('ProductMonographComponent')
      .subscribe((res) => {
        this.cmsResponse = res;
      });
    this.selectedChannel = sessionStorage.getItem('selectedChannel');
    this.cdr.detectChanges();
  }

  getDefaultB2b(userId): void {
    this.profilePrefService.getUserAccountDataFromDb(userId);
    this.subB2b = this.profilePrefService.userAccountData
      .pipe(take(1))
      .subscribe((userData) => {
        if (this.accountNumber === null) {
          this.accountNumber = userData?.res.defaultB2BUnit.uid;
          this.accountCnpj = userData?.res?.defaultB2BUnit?.cnpjNumber;
          this.customerGroupType =
            userData?.res.defaultB2BUnit.customerGroupType;
          this.cdr.detectChanges();
        }
      });
  }
  navigateToAccountDetails() {
    this.router.goByUrl('/my-account/profile');
    this.translateService
      .translate('profile.account')
      .subscribe((translation: string) => {
        this.checkoutService.tabSelection(translation);
      });
  }
  productMonograph() {
    this.productCodes = this.cmsResponse.productCodes;
    this.productCodes = this.productCodes.split(' ');
    this.productCodes.forEach((element) => {
      this.subProduct = this.productService.get(element).subscribe((res) => {
        if (res) {
          this.prodcutsInfo.push(res);
          this.cdr.detectChanges();
        }
      });
    });
  }
  selectChannelModal(): void {
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    const modalRef = this.modalService.open(
      ChannelSelectComponent,
      this.modalOption
    );
    modalRef.componentInstance.selectChannelSource = 'channel';
  }
  ngOnDestroy(): void {
    this.subEmulating?.unsubscribe();
    this.subB2b?.unsubscribe();
    this.subUser?.unsubscribe();
    this.subMonograph?.unsubscribe();
    this.subProduct?.unsubscribe();
  }
}
